/** import package [start] */
import { FC } from 'react';
/** import package [end] */

/** import custom dependency [start] */
import nextbtn from '../assets/next-stepbtn.png';
import backbtn from '../assets/back-stepbtn.png';
import shardeumlogo from '../assets/shardeum_dark.svg';
/** import custom dependency [end] */

/** type declaration for NextPrevFooter props */
export interface NextPrevFooterProps {
    isFirstPage: boolean;
    isLastPage: boolean;
    nextPage: () => void;
    prevPage: () => void;
    submitText: string;
    submit: () => void;
    nextDisabled?: boolean;
}

/**
 * NextPrevFooter component
 * @returns JSX.Element
 */
const NextPrevFooter: FC<NextPrevFooterProps> = ({
    isFirstPage,
    isLastPage,
    nextPage,
    prevPage,
    submitText,
    submit,
    nextDisabled,
}) => (
    <div>
        <hr className='mt-5 mb-5' />
        <div className='col-11 mb-5 mx-auto'>
            <div className='row'>
                <div className='col-xl-8 col-lg-8 col-md-2'>
                    <img src={shardeumlogo} alt='shardeum-logo' style={{ width: '100px' }} />
                </div>
                <div className='col-xl-4 py-1 col-lg-4 col-md-12 text-end'>
                    <div className='d-flex justify-content-end' style={{ gap: '10px' }}>
                        {!isFirstPage && (
                            <button
                                type='button'
                                className='btn btn-success bg-white text-black border'
                                onClick={() => prevPage()}
                            >
                                <img src={backbtn} alt='' />
                                <span>Back</span>
                            </button>
                        )}
                        {!isLastPage && (
                            <button type='button' className='btn btn-success' disabled={nextDisabled} onClick={() => nextPage()}>
                                <span>Next</span>
                                <img src={nextbtn} alt='' />
                            </button>
                        )}

                        {isLastPage && (
                            <button
                                type='button'
                                className='btn btn-success'
                                disabled={nextDisabled}
                                onClick={() => submit()}
                            >
                                <span>{submitText}</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </div>
);

NextPrevFooter.defaultProps = {
    submitText: 'Submit',
};

export default NextPrevFooter;
